import AppHeader from '../components/header/headNew.vue'
import AppFooter from '../components/footer/foot.vue'
export default{
    data(){
        return {
            meta:{
                header:false,
                footer:false,
                activeType:''
            }

        }
    },
   
    template:`
        <div style="min-width:1170px"> 
            <app-header :activeType="meta.activeType" v-if="meta.header"/>
            <div :style="style">
            <router-view ></router-view>
            </div>
            
            <app-footer v-if="meta.footer"/>
        </div>
    `,
    computed:{
        style(){
            let height=0;
            this.meta.header&&(height+=48)&&this.meta.footer&&(height+=70)
         return this.meta.heightAuto ? 'auto' : {minHeight:(window.screen.height-height-80)+'px'}
        }

    },
    created(){
        this.meta=this.$route.meta
    },
    updated(){
        this.meta=this.$route.meta
    },
    components:{AppHeader,AppFooter}
}



// WEBPACK FOOTER //
// ./src/containers/mainContainer.js